<template>
  <div>
    <CCol
      sm="12"
      style="background-size: cover; color: #fff"
      :style="{ backgroundImage: `url(${backgroundUrl})` }"
    >
      <CCol sm="12" lg="12">
        <CRow>
          <CCol sm="6" lg="6">
            <div style="margin-top: 20%">
              <h1 class="custom-header-title text-left">
                <strong> Online Tuition On Demand</strong>
              </h1>
              <h3 class="mt-3 text-white custom-header-subtitle text-left">
                Connect Students with best teachers <br />
                around the world
              </h3>
            </div>
            <br />
            <CButton color="success" size="lg" class="ml-5" href="https://www.pickiddo.com/partner"
              >Partner Login</CButton
            >
            <CButton color="primary" size="lg" class="ml-3">Sign Up</CButton>
          </CCol>
          <CCol sm="6" lg="6" class="mt-5">
            <!-- <h3 class="text-white text-center mt-2 custom-subtitle">Our Recommended Tutor</h3> -->
            <carousel-3d
              :autoplay="true"
              :autoplay-timeout="5000"
              :display="3"
              :height="380"
              :width="250"
            >
              <slide :index="0" class="bg-white">
                <img src="../assets/img/f1.png" />
                <h5 class="text-center text-black">
                  Set schedule and assign teacher on subject
                </h5>
              </slide>
              <slide :index="1" class="bg-white">
                <img src="../assets/img/f2.png" />
                <h5 class="text-center text-black">
                 Record Attendance Student and Teacher On System
                </h5></slide
              >
              <slide :index="2" class="bg-white">
                <img src="../assets/img/f3.png" />
                <h5 class="text-center text-black">
                 Monitor Learning class schedule anytime and anywhere
                </h5>
              </slide>
            </carousel-3d>
          </CCol>
        </CRow>
      </CCol>
    </CCol>
    <CCol sm="12" lg="12">
      <CContainer>
        <h1 class="text-center custom-title mt-5" data-aos="fade-up">
          Our Exclusive Tutor
        </h1>
        <CRow>
          <CCol sm="4" lg="4">
            <CCard data-aos="zoom-in">
              <div class="text-center">
                <img
                  width="120px"
                  height="120px"
                  class="p-2"
                  src="../assets/img/user1.png"
                />
                <br />
              </div>
              <h3 class="custom-header-subtitle text-black">Nichole David</h3>
              <div class="small text-muted text-center">Mathematic</div>
              <label class="custom-header-subtitl text-black m-3"
                >“I am genuinely caring towards my student’s academic
                performance and am willing to go to great lengths to....”</label
              >
              <div class="custom-btn-book">
                <a style="color: #fff" href="">BOOK NOW</a>
              </div>
            </CCard>
          </CCol>
          <CCol sm="4" lg="4">
            <CCard data-aos="zoom-in">
              <div class="text-center">
                <img
                  width="120px"
                  height="120px"
                  class="p-2"
                  src="../assets/img/roundUser2.png"
                />
              </div>
              <h3 class="custom-header-subtitle text-black">Nichole David</h3>
              <div class="small text-muted text-center">Mathematic</div>
              <label class="custom-header-subtitl text-black m-3"
                >“I am genuinely caring towards my student’s academic
                performance and am willing to go to great lengths to....”</label
              >
              <div class="custom-btn-book">
                <a style="color: #fff" href="">BOOK NOW</a>
              </div>
            </CCard>
          </CCol>
          <CCol sm="4" lg="4">
            <CCard data-aos="zoom-in">
              <div class="text-center">
                <img
                  width="120px"
                  height="120px"
                  class="p-2"
                  src="../assets/img/roundUser3.png"
                />
              </div>
              <h3 class="custom-header-subtitle text-black">Nichole David</h3>
              <div class="small text-muted text-center">Mathematic</div>
              <label class="custom-header-subtitl text-black m-3"
                >“I am genuinely caring towards my student’s academic
                performance and am willing to go to great lengths to....”</label
              >
              <div class="custom-btn-book">
                <a style="color: #fff" href="">BOOK NOW</a>
              </div>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </CCol>

    <CCol sm="12" lg="12" class="bg-white">
      <CContainer>
        <br />
        <h1 class="text-center custom-title mt-3 text-black" data-aos="fade-up">
          Browse Our Features
        </h1>
        <CRow>
          <CCol sm="6" lg="6" class="mt-5">
            <h1 class="circle-bg text-black mt-5">1</h1>
            <h1 class="custom-subtitle text-left text-black" data-aos="fade-up">
              Flexible Schedule
            </h1>
            <h3 class="mt-3 custom-subtitle-img text-left text-black">
              Flexible schedule gives you to choose to get lesson at your free
              time
            </h3>
          </CCol>
          <CCol sm="6" lg="6">
            <img max-width="100px" src="../assets/img/calendar.png" />
          </CCol>

          <CCol sm="6" lg="6">
            <img max-width="100px" src="../assets/img/subject.png" />
          </CCol>
          <CCol sm="6" lg="6" class="mt-5">
            <h1 class="circle-bg text-black mt-5">2</h1>
            <h1 class="custom-subtitle text-left text-black" data-aos="fade-up">
              Various Subject
            </h1>
            <h3 class="mt-3 custom-subtitle-img text-left text-black">
              Various subject that can be learnt that not just limited to normal
              course
            </h3>
          </CCol>
          <CCol sm="6" lg="6" class="mt-5">
            <h1 class="circle-bg text-black mt-5">3</h1>
            <h1 class="custom-subtitle text-left text-black" data-aos="fade-up">
              Best Tutor
            </h1>
            <h3 class="mt-3 custom-subtitle-img text-left text-black">
              Provide the best tutor for you to gain better study experience
            </h3>
          </CCol>
          <CCol sm="6" lg="6">
            <img max-width="100px" src="../assets/img/tutor.png" />
          </CCol>
        </CRow>
      </CContainer>
      <br /><br />
    </CCol>

    <CCol sm="12" lg="12" class="bg-blue-black">
      <CContainer>
        <br />
        <h1 class="text-center custom-title mt-3" data-aos="fade-up">
          Award and Recognition
        </h1>
        <CCol sm="12" lg="12">
          <CRow>
            <CCol sm="4" class="mt-5">
              <CCol sm="12">
                <CRow>
                  <CCol sm="4" lg="4"
                    ><h1 class="circle-bg text-white">1</h1></CCol
                  >
                  <CCol sm="8" lg="8" data-aos="zoom-in-down">
                    <img
                      style="max-width: 200px"
                      src="../assets/img/allianzeLogo.png"
                  /></CCol>
                </CRow>
                <h1
                  class="custom-subtitle-img text-left text-white mt-2"
                  data-aos="zoom-in-down"
                >
                  ALLIANZ INSURANCE - Partner
                </h1>
              </CCol>
              <br />
              <br />

              <CCol sm="12" class="mt-3">
                <CRow>
                  <CCol sm="4" lg="4"
                    ><h1 class="circle-bg text-white">2</h1></CCol
                  >
                  <CCol sm="8" lg="8" data-aos="zoom-in-down">
                    <img style="max-width: 200px" src="../assets/img/magic.png"
                  /></CCol>
                  <CCol sm="12">
                    <h1
                      class="custom-subtitle-img text-left text-white mt-2"
                      data-aos="zoom-in-down"
                    >
                      GLOBAL ACCELERATOR PROGRAMME (GAP) 2019 - Alumni
                    </h1>
                  </CCol>
                </CRow>
              </CCol>
            </CCol>
            <CCol sm="8">
              <img style="max-width: 100%" src="../assets/img/award.png" />
            </CCol>
          </CRow>
        </CCol>
      </CContainer>
    </CCol>

    <CCol sm="12" lg="12">
      <CContainer class="mt-5">
        <CCol sm="12" lg="12">
          <CRow>
            <CCol sm="4" lg="4">
              <h1 class="text-left mt-3" data-aos="fade-up">
                <strong>See our user data on our platform </strong>
              </h1>
            </CCol>
            <CCol sm="8" lg="8">
              <CRow>
                <CCol sm="4" lg="4">
                  <CCard
                    style="background: #2db5aa"
                    class="shadow p-3 mb-5 rounded"
                    data-aos="zoom-out-up"
                  >
                    <h1
                      style="font-size: -webkit-xxx-large"
                      class="text-white text-center"
                    >
                      150
                    </h1>
                    <label class="custom-subtitle-img text-white"
                      ><strong>Total Student</strong></label
                    >
                  </CCard>
                </CCol>
                <CCol sm="4" lg="4">
                  <CCard
                    style="background: #122881"
                    class="shadow p-3 mb-5 mt-5 rounded"
                    ><h1
                      style="font-size: -webkit-xxx-large"
                      class="text-white text-center"
                    >
                      52
                    </h1>
                    <label class="custom-subtitle-img text-white"
                      ><strong>Total Teacher</strong></label
                    ></CCard
                  >
                </CCol>
                <CCol sm="4" lg="4">
                  <CCard
                    style="background: #d55cb6"
                    class="shadow p-3 mb-5 rounded"
                    ><h1
                      style="font-size: -webkit-xxx-large"
                      class="text-white text-center"
                    >
                      20
                    </h1>
                    <label class="custom-subtitle-img text-white"
                      ><strong>Total Subject</strong></label
                    ></CCard
                  >
                </CCol>
              </CRow>
            </CCol>

            <!-- <CCol sm="4" lg="4" class="text-right">
              <h1 class="text-right countUser">463</h1>
              <h5 class="text-right mr-3"><strong>STUDENT</strong></h5>
            </CCol>
            <CCol sm="4" lg="4">
              <h1 class="text-center countUser">63</h1>
              <h5 class="text-center"><strong>TEACHER</strong></h5>
            </CCol>
            <CCol sm="4" lg="4" class="text-left">
              <h1 class="text-left countUser">43</h1>
              <h5 class="text-left mr-3"><strong>SUBJECT</strong></h5>
            </CCol> -->
          </CRow>
        </CCol>
      </CContainer>
    </CCol>

    <CCol sm="12" lg="12" class="bg-white">
      <CContainer>
        <div class="text-center p-3">
          <h1
            class="text-center mt-5 mb-5 text-black custom-title"
            data-aos="fade-up"
          >
            How It Work
          </h1>
          <img style="max-width: 100%" src="../assets/img/work1.gif" />
        </div>
      </CContainer>
    </CCol>
    <CCol sm="12" lg="12" class="bg-white">
      <CContainer>
        <CRow class="text-center">
          <marquee-text :duration="30">
            <div style="margin: 0 auto" class="text-center">
              <img
                style="max-width: 100px"
                src="../assets/img/akademiksinar.png"
              />
              <img style="max-width: 100px" src="../assets/img/asklah.png" />
              <img
                style="max-width: 100px"
                src="../assets/img/cempakawan.png"
              />
              <img style="max-width: 100px" src="../assets/img/ikondidik.png" />
              <img style="max-width: 100px" src="../assets/img/prestasi.png" />
              <img
                style="max-width: 100px"
                src="../assets/img/probestari.png"
              />
              <img style="max-width: 100px" src="../assets/img/ptsn.png" />
              <img style="max-width: 100px" src="../assets/img/rocketht.png" />
              <img
                style="max-width: 100px"
                src="../assets/img/sinarakademik.png"
              />
              <img
                style="max-width: 100px"
                src="../assets/img/teratakilmu.png"
              />
            </div>
          </marquee-text>
        </CRow>
      </CContainer>
    </CCol>

    <CCol sm="12" lg="12">
      <CContainer>
        <CRow class="mt-5">
          <CCol class="mt-5">
            <h1 class="text-right">
              <strong>Introducing our Pickiddo Apps</strong>
            </h1>
            <br />
            <h5 class="text-right">
              To manage many part of your kid's education such as to provide a
              strog bridge communication between parent and Tuition Center
              teacher
            </h5>
            <div class="text-right mt-5">
              <img
                class="text-center"
                style="max-width: 120px"
                src="../assets/img/googleplay.png"
              />
              <img
                style="max-width: 120px"
                class="ml-2"
                src="../assets/img/ios.png"
              />
            </div>
          </CCol>
          <CCol sm="4">
            <img style="max-width: 300px" src="../assets/img/bgphone.png" />
          </CCol>
          <CCol sm="4">
            <CCol sm="12" lg="12">
              <h1 class="custom-subtitle">Our Feature's App</h1>
              <CRow class="mt-4">
                <CCol sm="3">
                  <h1 class="circle-bg">1</h1>
                </CCol>
                <CCol sm="9">
                  <h5>AskKiddo</h5>
                  <label
                    >Type your comment or anything to ask in Askiddo
                  </label>
                </CCol>

                <CCol sm="3">
                  <h1 class="circle-bg">2</h1>
                </CCol>
                <CCol sm="9">
                  <h5>Tutor</h5>
                  <label
                    >List of Teacher schedule, attendance, evaluation and salary
                    can be viewed</label
                  >
                </CCol>

                <CCol sm="3">
                  <h1 class="circle-bg">3</h1>
                </CCol>
                <CCol sm="9"
                  ><h4>Payment</h4>
                  <label
                    >History of total Unpiad and total Paid as reference</label
                  >
                </CCol>

                <CCol sm="3">
                  <h1 class="circle-bg">4</h1>
                </CCol>
                <CCol sm="9"
                  ><h4>Ewallet</h4>
                  <label
                    >Parent can used Ewallet to pay fee for their parent</label
                  >
                </CCol>
              </CRow>
            </CCol>
          </CCol>
        </CRow>
      </CContainer>
    </CCol>

    <CCol sm="12" lg="12" class="bg-white">
      <CContainer class="mb-3 mt-5">
        <div class="text-center mb-3">
          <CCol style="margin: 0 auto" sm="12">
            <h1 class="text-center mb-5 text-black custom-title">
              <br />
              How It Work On Apps
            </h1>
            <CRow>
              <CCol sm="3" lg="3">
                <img style="max-width: 100%" src="../assets/img/app1.png" />
              </CCol>
              <CCol sm="6">
                <video
                controls
                loop
                  style="max-width: 100%"
                  :src="video"
                  data-aos="zoom-in-down"
                  :options="playerOptions"
                  :autoplay="true"
                ></video>
                <h1 class="text-center mb-5 text-black custom-subtitle"></h1>
              </CCol>
              <CCol sm="3" lg="3">
                <img style="max-width: 100%" src="../assets/img/app2.png" />
              </CCol>
            </CRow>
          </CCol>
        </div>
      </CContainer>
    </CCol>

    <CCol
      sm="12"
      lg="12"
      style="background-size: cover; color: #fff; margin-top: -20px"
      :style="{ backgroundImage: `url(${backgroundFeed})` }"
    >
      <br />
      <h1 class="text-center mt-5 custom-title">Our Feedback</h1>
      <CContainer>
        <div class="text-center">
          <CCol style="margin: 0 auto" sm="12">
            <CCarousel indicators animate height="200px">
              <CCarouselItem>
                <h4 class="custom-header-subtitle">
                  <i>
                    Pickiddo give me a platform to get my son study from home in
                    affordable price</i
                  >
                </h4>
                <h3 class="custom-header-subtitle">
                  <strong>Paul, father of the student</strong>
                </h3>
              </CCarouselItem>

              <CCarouselItem>
                <h4 class="custom-header-subtitle">
                  <i>
                    A very good platform. So many knowledgable tutor to choose
                    from. Keep up the good work!</i
                  >
                </h4>
                <h3 class="custom-header-subtitle">
                  <strong>Lisa, mother of two students</strong>
                </h3>
              </CCarouselItem>
              <CCarouselItem>
                <h4 class="custom-header-subtitle">
                  <i>
                    Pickiddo offers a way for my daugther to get study during
                    this horibble pandemic</i
                  >
                </h4>
                <h3 class="custom-header-subtitle">
                  <strong>David, father of the student</strong>
                </h3>
              </CCarouselItem>
            </CCarousel>
          </CCol>
        </div>
      </CContainer>
    </CCol>

    <CCol sm="12" lg="12" class="p-5 bg-blue-black">
      <CRow>
        <CCol sm="3" lg="3">
          <h5 class="titleFooter">PREFACE</h5>
          <br />
          <label
            >A cloud based platform designed to help tuition center to control
            and manage their administration in more efficient with smart search
            feature that more flexible to retrieve records. Pickiddo helps to
            manage students' payment and issues official receipts without any
            hassle.</label
          >
        </CCol>
        <CCol sm="3" lg="3">
          <h5 class="titleFooter">BODY</h5>
          <br />
          <h5>ABOUT</h5>
          <br />
          <h5>BLOG</h5>
        </CCol>
        <CCol sm="3" lg="3">
          <h5 class="titleFooter">REFERENCE</h5>
          <br />
          <h5>GUIDE</h5>
        </CCol>
        <CCol sm="3" lg="3">
          <h5 class="titleFooter">CONTACT</h5>
          <br />
          <h5>CONTACT US</h5>
        </CCol>
      </CRow>
    </CCol>
  </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg3.png";
import backgroundColor from "../assets/img/bgcolor.jpg";
import backgroundFeed from "../assets/img/bgWhatwesay.png";
import backgroundPhone from "../assets/img/bgphone1.png";
import user1 from "../assets/img/user5.png";
import video from "../assets/img/app3.mp4";
export default {
  name: "Login",
  components: {
    Carousel3d,
    Slide,
    MarqueeText,
  },
  
  data() {
    return {
      backgroundUrl,
      backgroundColor,
      backgroundFeed,
      backgroundPhone,
      video,

      user1,
      slides: 7,
      autoplay: true,
      loop: true,
      playerOptions: {
        loop: true,
        autoplay: true,
      },
      autoplay: {
        // automatically play the video
        type: Boolean,
        default: () => true,
      },
      loop: {
        // loop the video infinitely
        type: Boolean,
        default: () => true,
      },
    };
  },
  created() {
    AOS.init();
  },
  methods: {
    onAfterSlideChange(index) {
      console.log(
        "@onAfterSlideChange Callback Triggered",
        "Slide Index " + index
      );
    },
    onBeforeSlideChange(index) {
      console.log(
        "@onBeforeSlideChange Callback Triggered",
        "Slide Index " + index
      );
    },
    onLastSlide(index) {
      console.log("@onLastSlide Callback Triggered", "Slide Index " + index);
    },
  },
};
</script>
